import { Pagination } from "react-bootstrap";

export type PagerProps = {
  readonly page: number;
  readonly pageSize: number;
  readonly total: number;
  readonly onPageChange: (page: number) => void;
};

export const pageSlice = <T,>(items: readonly T[], page: number, pageSize: number): T[] =>
  items.slice((page - 1) * pageSize, page * pageSize);

const Pager = ({ page, pageSize, total, onPageChange }: PagerProps) => {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <Pagination size="sm" className="mb-0 align-items-center">
      <Pagination.Prev aria-label="Previous page" disabled={page <= 1} onClick={() => onPageChange(page - 1)} />
      <Pagination.Item disabled>
        Page {page} of {pages}
      </Pagination.Item>
      <Pagination.Next aria-label="Next page" disabled={page >= pages} onClick={() => onPageChange(page + 1)} />
    </Pagination>
  );
};

export default Pager;
